<template>
  <div style="background: white">
    <prohead></prohead>
    <div>

      <div>
        <div class="banner" style="background: url('../../static/img/k_bg.jpg');position: relative">
          <div style="position: absolute;left: 46%">联系方式</div>
        </div>
        <ul class="tab-title">
          <li v-for="(title,index) in tabTitle" @click="cur=title.cate_name" :class="{active:cur==title.cate_name}">{{title.cate_name}}</li>
        </ul>
        <div class="contactus_banner"  v-show = "cur == '联系方式'">
          免费热线 ： 400-0616-123  <br>
          北京公司 ：北京市房山区天星街1号院绿地启航国际15号楼18楼<br>
          湖北公司 ： 湖北省武汉市东西湖大道与孝武大道交汇处509号 <br>
          成都公司 ： 四川省成都市金牛区金科南路169号1栋9号905室 <br>
          <img src="../../static/img/lianxifangshi.png" alt="">
        </div>
      </div>
    </div>
      <div v-show="cur == '在线留言'" style="background: #ffffff;padding-bottom: 50px">
        <div class="submitet">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="姓名" prop="name">
              <div style="float: left"><el-input style="width: 230px" v-model="ruleForm.name"></el-input> </div>
              <div style="float: left"><el-select style="width: 80px;margin-left: 10px" v-model="ruleForm.region" placeholder="性别">
                <el-option label="男" value="shanghai"></el-option>
                <el-option label="女" value="beijing"></el-option>
              </el-select></div>
              <div style="float: left;" class="sub_text"><span>仅供客服服务交流，不必提供完整姓名</span></div>
            </el-form-item>
            <el-form-item label="电话" prop="ipone">
              <div style="float: left"> <el-input  style="width: 320px" v-model="ruleForm.ipone" maxlength="11" oninput = "value=value.replace(/[^\d]/g,'')"></el-input></div>
              <div style="float: left" class="sub_text"> <span>请您提供联系方式，方便客服人员服务</span></div>
            </el-form-item>
            <el-form-item label="邮件" prop="postal">
              <div style="float: left"> <el-input style="width: 320px" v-model="ruleForm.postal"></el-input></div>
              <div style="float: left" class="sub_text"><span>资料发送邮件</span></div>
            </el-form-item>
            <el-form-item label="所在城市" prop="city">
              <div style="float: left"> <el-input style="width: 320px" v-model="ruleForm.city"></el-input></div>
              <div style="float: left" class="sub_text"> <span>帮助我们更加准确的为您服务</span></div>
            </el-form-item>
            <el-form-item label="内容" prop="desc">

              <el-input type="textarea" style="width: 320px" v-model="ruleForm.desc"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="boxtom" type="primary" @click="submitForm('ruleForm')">提交</el-button>
              <el-button class="rule" @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    <Profooter></Profooter>
  </div>

</template>

<script>
import Prohead from '../components/Prohead'
import Profooter from "../components/Profooter";
export default {
  name: "index",
  components: {Prohead,Profooter},
  data(){
    return {
      ruleForm: {
        name: '',
        region: '',
        ipone: '',
        city: '',
        postal: '',
        desc: ''
      },
      rules: {
        // name: [
        //   { required: true, message: '请输入活动名称', trigger: 'blur' },
        // ],
        // region: [
        //   { required: true, message: '请选择活动区域', trigger: 'change' }
        // ],
        //
        // resource: [
        //   { required: true, message: '请选择活动资源', trigger: 'change' }
        // ],
        // desc: [
        //   { required: true, message: '请填写内容', trigger: 'blur' }
        // ]
      },
      cur: '联系方式',
      tabTitle:[{
        cate_name:'联系方式'
      },{
        cate_name:'在线留言'
      }],
      la_id: "",
      nowurl: "",
    }
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.id == undefined) {
        this.cur = '联系方式'
      } else {
        if (this.$route.query.id) {

          this.cur  = this.$route.query.id
        }
      }

    }
  },
  created() {
    if(this.$route.query.id!= undefined){
      this.cur = this.$route.query.id
    }else{
      this.cur = '联系方式'
    }
  },
  methods:{
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formdata = new FormData()
          formdata.append('user_name',this.ruleForm.name)
          formdata.append('sex',this.ruleForm.region)
          formdata.append('tel_phone',this.ruleForm.ipone)
          formdata.append('email',this.ruleForm.postal)
          formdata.append('city',this.ruleForm.city)
          formdata.append('content',this.ruleForm.desc)
          this.$axios.post('/index/Message/addMessage',formdata).then(res => {
            if(res.data.code == 1){
              this.$message(res.data.msg);
            }else{
             this.$message({message: res.data.msg, type: 'error'});
           }
          });

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submit(){


    }
  }
}
</script>

<style scoped>
.tab-title{
  width: 1300px;
  height: 100px;
  margin: 0 auto;
  padding-top:30px;

}
.tab-title li:hover{
  cursor: pointer;
}
.tab-title li{
  width: 180px;
  height: 60px;
  border-radius: 30px;
  float: left;
  border: 1px solid #C5C5C5;
  line-height: 60px;
  text-align: center;
  margin-right: 20px;
  font-size: 18px;
}
.tab-title .active {
  background: #EA5C48;
  color: white;
  cursor: pointer;
  border: 1px solid #EA5C48;
}
.contactus_banner{
  width:775px;
  height: 680px;
  margin: 0 auto;
  font-size: 18px;
  font-family: PingFang;
  font-weight: 500;
  color: #000000;
  line-height: 48px;
  padding-top: 65px;
}
.banner_pin div{
  float: left;
}
.box3{
  margin: 0 auto;
  width: 100%;
  height: 618px;
  //background: url("../../static/img/bg2.jpg");
}
.box_banner2{
  width: 1300px;
  margin: 0 auto;
  height: 620px;
  text-align: center;
}
.box_imgbanner div{
  float: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
  text-align: left;
}
.box_imgbanner{
  margin-top: 60px;
}
.banner_pintext{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.titlebox{
  text-align: center;
  font-size: 40px;
  font-weight: 500;
}
.title_fu{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  text-align: center;
}
.banner{
  height: 300px;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 300px;
  text-align: center;
}
.banner_kai{
  width: 1300px;
  height: 894px;
  margin: 0 auto;
}
.boxtom{
  width: 150px;
  height: 40px;
  background: #EA5C48 !important;
  border-radius: 1px !important;
  border: 1px solid #EA5C48 !important;
}
.rule{
  width: 150px;
  height: 40px;
  border-radius: 1px !important;
}
.sub_text{
  margin-left: 10px;
  font-size: 12px;
  color:darkgray;
}
.submitet{
  width: 700px;
  padding-top: 30px;
  margin: 0 auto;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/contactus.vue